import * as htmlToImage from 'html-to-image';

/*
    Returns a png of the ProfileV2 Scorecard, on a larger background image
    - Adds shadow
    - Removes any shine animation first
*/
export default async function getProfileV2ShareImage(backgroundUrl: string) {
    const node = document.getElementById('arise-profile-scorecard');

    const BACKGROUND_WIDTH = 704; // 16:9
    const BACKGROUND_HEIGHT = 396;
    const OVERLAY_PIXEL_RATIO = 4;
    const OVERLAY_PADDING_OFFSET = 25;
    const EXPORT_SCALE = 2;

    // Stop shine animation so it's not captured
    node.classList.add('stop-all-animations');

    // Do it once first to ensure all assets load in and stop safari bug
    await htmlToImage.toPng(node);

    const overlayDataUrl = await htmlToImage.toPng(node, {
        pixelRatio: OVERLAY_PIXEL_RATIO,
        style: { filter: 'none' },
    });

    node.classList.remove('stop-all-animations');

    let backgroundImg: HTMLImageElement | null = null;
    try {
        backgroundImg = await new Promise<HTMLImageElement>((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = backgroundUrl;
        });
    } catch {
        backgroundImg = null;
    }

    const overlayImg = await new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = overlayDataUrl;
    });

    const canvas = document.createElement('canvas');
    canvas.width = BACKGROUND_WIDTH * EXPORT_SCALE;
    canvas.height = BACKGROUND_HEIGHT * EXPORT_SCALE;
    const ctx = canvas.getContext('2d');

    // Draw background at full size
    if (backgroundImg) {
        ctx.drawImage(backgroundImg, 0, 0, canvas.width, canvas.height);
    } else {
        ctx.fillStyle = '#181818'; // Fallback grey bg
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }

    // Scale overlay down to reverse pixelRatio = 4
    const scaledWidth = (overlayImg.width / OVERLAY_PIXEL_RATIO) * EXPORT_SCALE;
    const scaledHeight = (overlayImg.height / OVERLAY_PIXEL_RATIO) * EXPORT_SCALE;

    // Draw overlay at requested position with drop shadow
    ctx.save();
    ctx.filter = 'drop-shadow(5px 5px 8px rgba(0,0,0,0.8))';
    ctx.drawImage(
        overlayImg,
        canvas.width - scaledWidth - OVERLAY_PADDING_OFFSET * EXPORT_SCALE,
        OVERLAY_PADDING_OFFSET * EXPORT_SCALE,
        scaledWidth,
        scaledHeight,
    );
    ctx.restore(); // Remove the filter state in case we want to draw more things

    const blob = await getCanvasBlob(canvas);
    const url = URL.createObjectURL(blob);

    // (Optional) Append to DOM for testing
    // const testImg = new Image();
    // testImg.src = url;
    // testImg.style = `
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     z-index: 10000;
    //     width: 50%;
    //     border: 1px solid red;
    // `;
    // document.body.appendChild(testImg);

    return url;
}

function getCanvasBlob(canvas: HTMLCanvasElement): Promise<Blob> {
    return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/png');
    });
}
